"use client";

import { useRouterState } from "@tanstack/react-router";
import type { ComponentProps } from "react";

import { Link } from "@/components/link";
import {
  buildLoginHrefWithRedirect,
  getRedirectPathFromLocation,
  type LoginMode,
} from "@/lib/redirect-after-login";

type LoginLinkProps = Omit<ComponentProps<typeof Link>, "to"> & {
  redirectPath?: string;
  mode?: LoginMode;
};

export function LoginLink({ redirectPath, mode, rel = "nofollow", ...props }: LoginLinkProps) {
  const location = useRouterState({ select: (state) => state.location });
  const href = buildLoginHrefWithRedirect(redirectPath ?? getRedirectPathFromLocation(location), {
    mode,
  });

  return <Link to={href} rel={rel} {...props} />;
}
